import { useEffect, useState } from 'react';
import * as Atom from '../recoil';
import { beaconSelector } from '../recoil/selector';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useParams } from 'react-router-dom';
import useBeacon from '../hooks/useBeacon';
import useNav from '../hooks/useNav';
import { useBaseParam } from '../hooks/useBaseParam';
import { mutateMonthlyRequestInsert } from '../../infra/api/mutateMonthlyRequestInsert';
import { fetchMonthlyRequestDetail } from '../../infra/api/fetchMonthlyRequestDetail';
import { fetchCustTotalProductSummary } from '../../infra/api/fetchCustTotalProductSummary';
import {
  EVENT_NOTI_PRE_REG,
  EVENT_PAGE,
  EVENT_REQUEST,
  PAGE_NM,
} from '../types/types';
import { EXPLAIN } from '../staticData/info/NOTI_PRE_REG';
import { TERM_NOTI } from '../staticData/terms';
import PROMOTION from '../staticData/notiPromotion';
import eventTimer from '../helper/eventTimer';
import { useTermFullsheet } from '../hooks/useTermFullsheet';
import { useTermBottomsheet } from '../hooks/useTermBottomsheet';
import { useTerms } from '../hooks/useTerms';

const useNotiPreReg = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.NOTI_PRE_REG,
  });
  const sendBeaconClkBtnSchAlertApp = (btnNm: string) => {
    beacon.sendClkBtnSchAlertApp({
      properties: { btnNm },
    });
  };
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const { navigate } = useNav();
  const { media } = useParams();
  const [personal] = useRecoilState(Atom.personalInfo);
  const [serverTime, setServerTime] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [productDayInfo, setProductDayInfo] = useState<any>();
  const [monthlyRequestInfo, setMonthlyRequestInfo] = useState<any>();
  const [popup, setPopup] = useState({
    open: false,
    message: '신청이 완료되었어요.',
    hasConfirmButton: false,
    hasCancelButton: false,
  });
  const PROMOTION_INFO = media === undefined ? null : PROMOTION[media];

  const EVENT_TYPE = {
    monthlyRequestYn: EVENT_NOTI_PRE_REG.monthlyRequestYn,
    agreeYn: EVENT_NOTI_PRE_REG.agreeYn,
  };

  const getCustProductInfoDay = useBaseParam(fetchCustTotalProductSummary, {
    custSeq: personal.custSeq,
  });
  const getMonthlyRequestDetail = useBaseParam(fetchMonthlyRequestDetail, {
    custSeq: personal.custSeq,
  });
  const setMonthlyInsert = useBaseParam(mutateMonthlyRequestInsert, {
    custSeq: personal?.custSeq,
    agreeYn: EVENT_TYPE.agreeYn,
  });
  const applyMonthlyPreRequest = async () => {
    const res = await setMonthlyInsert();
    if (res?.data?.isSucceed === true) {
      if (res?.data?.result) {
        setPopup((prev) => ({
          ...prev,
          open: true,
        }));

        setTimeout(() => {
          setPopup((prev) => ({
            ...prev,
            open: false,
          }));
          navigate('/main');
        }, 1000);
      }
    }
  };

  const preRequestToday =
    productDayInfo?.preRequestInfoChk && productDayInfo?.dayAgo === 0;
  const isMonthlyRequestCompleted =
    monthlyRequestInfo?.monthlyRequestYn === 'Y';
  const shouldMonthlyRequest = preRequestToday && !isMonthlyRequestCompleted;
  const buttonText = !isMonthlyRequestCompleted
    ? '신청하기'
    : '정기 알림 신청 완료';

  useEffect(() => {
    setIsLoading(true);
    if (!personal.custSeq) {
      setIsLoading(false);
      return;
    }
    (async () => {
      const [resProductInfoDay, resMonthlyRequestInfo] = await Promise.all([
        getCustProductInfoDay(),
        getMonthlyRequestDetail(),
      ]);

      if (resProductInfoDay?.data?.isSucceed === true) {
        setProductDayInfo(resProductInfoDay.data.result);
      }

      if (resMonthlyRequestInfo?.data?.isSucceed === true) {
        setMonthlyRequestInfo(resMonthlyRequestInfo.data.result);
        setServerTime(resMonthlyRequestInfo.data.responseTime);
      }

      setIsLoading(false);
    })();
  }, []);

  //
  const terms = useTerms();

  const termBottomsheet = useTermBottomsheet(TERM_NOTI, 'essential');

  const termFullsheet = useTermFullsheet();
  const openTermFullsheet = (checkItemIdx: number) => {
    const { title, path, termsCd } = termBottomsheet.findItem(checkItemIdx);
    termFullsheet.open(title, path, termsCd);
  };

  //
  const submitEvent = () => {
    if (shouldMonthlyRequest) {
      applyMonthlyPreRequest && applyMonthlyPreRequest();
    } else {
      if (media === 'lgu') {
        terms.processAgreeTermLgu &&
          terms.processAgreeTermLgu(undefined, {
            EVENT_PAGE: EVENT_PAGE.NOTI_PRE_REG,
            EVENT_REQUEST: EVENT_REQUEST.PRE_REQUEST,
            EVENT_STATE: {
              monthlyRequestYn: 'Y',
              agreeYn: 'N',
            },
            EVENT_OPTION: '',
          });
      } else {
        terms.navigateTerm({
          EVENT_PAGE: EVENT_PAGE.NOTI_PRE_REG,
          EVENT_REQUEST: EVENT_REQUEST.PRE_REQUEST,
          EVENT_STATE: {
            monthlyRequestYn: 'Y',
            agreeYn: 'N',
          },
          EVENT_OPTION: '',
        });
      }
    }
  };

  const ctaEvent = () => {
    sendBeaconClkBtnSchAlertApp('정기 알림 신청하기');
    termBottomsheet.open();
  };

  return {
    isLoading,
    isMonthlyRequestCompleted,
    shouldMonthlyRequest,
    hasPromotion:
      PROMOTION_INFO &&
      eventTimer(PROMOTION_INFO?.start, PROMOTION_INFO?.end, serverTime) &&
      !isMonthlyRequestCompleted,

    media,
    buttonText,
    popup,
    BANNER: PROMOTION_INFO?.BANNER,
    EXPLAIN,
    TERM_NOTI,
    EVENT_TYPE,

    applyMonthlyPreRequest,
    sendBeaconClkBtnSchAlertApp,

    terms,
    termBottomsheet,
    termFullsheet,
    openTermFullsheet,

    submitEvent,
    ctaEvent,
  };
};

export default useNotiPreReg;
